import { select } from 'core/middlewares/utilities';

import type { RootState } from 'core/store';

/**
 * Get default shippingModel
 *
 */
export function* getShippingModelToggle() {
  const { toggleActive }: RootState['shippingModel'] = yield select(
    ({ shippingModel }: RootState) => shippingModel,
  );
  return toggleActive;
}

/**
 * Get default shippingModel
 *
 */
export function* getDefaultShippingModel() {
  const { data }: RootState['shippingModel'] = yield select(
    ({ shippingModel }: RootState) => shippingModel,
  );
  return data.default;
}

/**
 * Get availables shippingModel
 *
 */
export function* getAvailablesDeliveries() {
  const { data }: RootState['shippingModel'] = yield select(
    ({ shippingModel }: RootState) => shippingModel,
  );
  return data.availables;
}
